import React from 'react';

const TONES = {
  neutral: { accent: 'var(--sand-600)', icon: '•' },
  success: { accent: 'var(--success)', icon: '✓' },
  warning: { accent: 'var(--warning)', icon: '!' },
  danger:  { accent: 'var(--danger)', icon: '✕' },
  accent:  { accent: 'var(--accent)', icon: '♟' },
};

export function Toast({ tone = 'neutral', title, children, onClose, style = {} }) {
  const t = TONES[tone] || TONES.neutral;
  return (
    <div style={{
      display: 'flex', alignItems: 'flex-start', gap: 12,
      background: 'var(--surface-raised)', border: '1px solid var(--border-subtle)',
      borderLeft: `4px solid ${t.accent}`, borderRadius: 'var(--radius-md)',
      padding: '14px 16px', boxShadow: 'var(--shadow-md)', maxWidth: 380,
      animation: 'kor-rise var(--dur-base) var(--ease-out)', ...style,
    }}>
      <span style={{
        width: 24, height: 24, borderRadius: '50%', background: t.accent, color: '#fff',
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 13, fontWeight: 700, flexShrink: 0,
      }}>{t.icon}</span>
      <div style={{ flex: 1 }}>
        {title && <div style={{ fontSize: 'var(--text-md)', fontWeight: 'var(--weight-semibold)', color: 'var(--text-primary)' }}>{title}</div>}
        {children && <div style={{ fontSize: 'var(--text-sm)', color: 'var(--text-secondary)', marginTop: 2 }}>{children}</div>}
      </div>
      {onClose && <button onClick={onClose} aria-label="Закрыть" style={{ border: 'none', background: 'none', cursor: 'pointer', color: 'var(--text-muted)', fontSize: 16, padding: 0 }}>✕</button>}
    </div>
  );
}
